import { useEffect, useState } from "react";

import { Link } from "@icg360/design-system";

import { useEnvelopeToSign } from "hooks/use-envelope-to-sign";
import {
  type BadgeProps,
  WelcomeBannerSection,
} from "pages/overview/welcome-banner/welcome-banner-section";
import { trackEvent } from "utils";

const SignatureSection = () => {
  const { envelopeToSign, loading } = useEnvelopeToSign();
  const [badgeProps, setBadgeProps] = useState<BadgeProps>();

  useEffect(() => {
    trackEvent("welcomeTaskCard_documents_load");
  }, []);

  useEffect(() => {
    setBadgeProps(
      envelopeToSign
        ? { appearance: "warning", text: "Incomplete" }
        : undefined,
    );
  }, [envelopeToSign]);

  return (
    <WelcomeBannerSection
      title="Documents"
      badgeProps={badgeProps}
      footer={
        <Link
          appearance="secondary"
          href="/my/documents"
          size="sm"
          onPress={() =>
            trackEvent("welcomeTaskCard_eSign_goToDocuments", {
              hasDocumentsToSign: !!envelopeToSign,
            })
          }
        >
          Go to documents
        </Link>
      }
      loading={loading}
    >
      {envelopeToSign ? (
        <div>
          You have documents that require your electronic signature. You can
          find them on the Documents page.
        </div>
      ) : (
        <div>You have no documents to sign.</div>
      )}
    </WelcomeBannerSection>
  );
};

export default SignatureSection;
